import { ViewModel, View, ObservableArray, ViewModelMessage } from "binder"
import { relativeTimeThreshold } from "moment";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { DragDropPossibilityChecker, DropAppliedViewModelMessage } from "uicomponents";
import { MenuOrderManipulationView } from "./menuOrderManipulation-view"


type toParseMenu = {
    id: string;
    name: string[];
    position: number;
};
type toSaveMenu = {
    id: string;
    name: string;
    position: number;
};
export class MenuOrderManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("menuOrderManipulation-viewModel.menuSettings", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.rootList = ObservableArray.create<Menu>();
        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new MenuOrderManipulationView();
    }
    public getTypeId(): string {
        return "VM-0C4C1DB4-E8C6-472A-A3F6-E47D525CCA47"
    }

    public set root(v: Menu) { this._root = v; } public get root(): Menu { return this._root; } private _root: Menu;
    public set rootList(v: ObservableArray<Menu>) { this._rootList = v; } public get rootList(): ObservableArray<Menu> { return this._rootList; } private _rootList: ObservableArray<Menu>;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    udpateIds(root: ObservableArray<Menu>, element) {
        if (element && root) {
            let item = root.filter(x => x.name == (element.Name ?? "")).at(0);
            if (item) {
                item.infoId = element.Id;
                item.icon = element.Icon;
                element.Children.forEach(e2 => {
                    this.udpateIds(item.children, e2);
                });
            }
        }
    }
    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/GetAllForms', {
            });
            let forms = result.Forms;
            let root = new Menu(this, null);
            forms.forEach(element => {
                root.parse({
                    id: element.Id,
                    name: element.Name.split('/'),
                    position: element.Position
                });
            });
            root.sort();
            this.root = root;
            root.name = '';
            this.rootList.update(...[root]);
            this.udpateIds(this.rootList, result.Path);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async save() {
        try {
            this.isLoading = true;
            let menus = this.root.getActionMenus();
            menus.forEach((x, i) => x.position = i + 1);
            let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/UpdateFormLocations', {
                Forms: menus.map(x => {
                    return {
                        Id: x.id,
                        Name: x.name,
                        Position: x.position
                    }
                }),
                PathRoot: this.root.GetPathInfo()
            });
            if (result.IsSuccessful) {
                await this.messageBoxConfirmSuccess(translate("menuOrderManipulation-viewModel.operationSuccessfully", {}), translate("menuOrderManipulation-viewModel.successfulOperation", {}));
            } else {
                await this.messageBoxConfirmWarning(translate("menuOrderManipulation-viewModel.operationErorr", {}), translate("menuOrderManipulation-viewModel.error", {}));
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(translate("menuOrderManipulation-viewModel.error", {}), translate("menuOrderManipulation-viewModel.error", {}));
        } finally {
            this.isLoading = false;
        }
    }
}


export class Menu extends ViewModel {
    GetPathInfo() {
        return {
            Id: this.infoId,
            Name: this.name,
            Icon: this.icon,
            AuthenticationFormId: this.id,
            Children: this.children.map(x => x.GetPathInfo())
        };
    }
    getFullName(): string {
        if (this.parentMenu == null) {
            return this.name;
        } else {
            return `${this.parentMenu.getFullName()}->${this.name}`;
        }
    }
    getActionMenus(): toSaveMenu[] {
        if (stringIsNullOrEmpty(this.id) == false) {
            return [{ id: this.id, name: this.name.trim(), position: this.position }];
        } else {
            let result: toSaveMenu[] = [];
            this.children.forEach(x => result.push(...x.getActionMenus()));
            if (this.parentMenu != null) {
                result.forEach(x => x.name = `${this.name}/${x.name}`);
            }
            return result;
        }
    }
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel, parentMenu: Menu) {
        super(parent);

        this.children = ObservableArray.create<Menu>();
        this.beforeDropPlace = new dropPlace(this, this, true, false, false);
        this.afterDropPlace = new dropPlace(this, this, false, true, false);
        this.childDropPlace = new dropPlace(this, this, false, false, true);
        this.parentMenu = parentMenu;
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set infoId(v: string) { this._infoId = v; } public get infoId(): string { return this._infoId; } private _infoId: string;
    public set icon(v: string) { this._icon = v; } public get icon(): string { return this._icon; } private _icon: string;

    public set childDropPlace(v: dropPlace) { this._childDropPlace = v; } public get childDropPlace(): dropPlace { return this._childDropPlace; } private _childDropPlace: dropPlace;
    public set beforeDropPlace(v: dropPlace) { this._beforeDropPlace = v; } public get beforeDropPlace(): dropPlace { return this._beforeDropPlace; } private _beforeDropPlace: dropPlace;
    public set afterDropPlace(v: dropPlace) { this._afterDropPlace = v; } public get afterDropPlace(): dropPlace { return this._afterDropPlace; } private _afterDropPlace: dropPlace;
    public set children(v: ObservableArray<Menu>) { this._children = v; } public get children(): ObservableArray<Menu> { return this._children; } private _children: ObservableArray<Menu>;
    public set parentMenu(v: Menu) { this._parentMenu = v; } public get parentMenu(): Menu { return this._parentMenu; } private _parentMenu: Menu;
    public set position(v: number) { this._position = v; } public get position(): number { return this._position; } private _position: number;

    addChild(): Menu {
        let newMenu = new Menu(this, this);
        newMenu.name = '';
        this.children.push(newMenu);
        return newMenu;
    }

    remove() {
        this.parentMenu?.removeChild(this);
    }
    removeChild(menu: Menu) {
        this.children.remove(menu);
    }
    takeInAfterSibling(menu: Menu) {
        this.parentMenu?.takeInChildAfter(menu, this);
    }
    takeInBeforeSibling(menu: Menu) {
        this.parentMenu?.takeInChildBefore(menu, this);
    }
    takeInChild(menu: Menu) {
        menu.parentMenu?.removeChild(menu);
        menu.parentViewModel = this;
        menu.parentMenu = this;
        this.children.push(menu);
    }
    takeInChildBefore(newMenu: Menu, before: Menu) {
        newMenu.parentMenu?.removeChild(newMenu);
        newMenu.parentViewModel = this;
        let index = this.children.indexOf(before);
        newMenu.parentMenu = this;
        this.children.insertAt(index, newMenu);
    }
    takeInChildAfter(newMenu: Menu, after: Menu) {
        newMenu.parentMenu?.removeChild(newMenu);
        newMenu.parentViewModel = this;
        let index = this.children.indexOf(after) + 1;
        newMenu.parentMenu = this;
        this.children.insertAt(index, newMenu);
    }

    parse(info: toParseMenu) {
        if (info.name.length > 0) {
            let name = info.name.shift();
            let relatedChild = this.children.filter(x => x.name == name).at(0);
            if (relatedChild == null) {
                relatedChild = this.addChild();
                relatedChild.name = name;
            }
            if (info.name.length == 0) {
                relatedChild.id = info.id;
                relatedChild.position = info.position;
            } else {
                relatedChild.parse(info);
            }
        }
    }

    sort() {
        if (this.children.length > 0) {
            this.children.forEach(x => x.sort());
            this.position = this.children.reduce((a, c) => a < c.position ? a : c.position, 32000);
            this.children.sort((a, b) => a.position - b.position);
        }
    }
}

export class dropPlace extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel, menu: Menu, before?: boolean, after?: boolean, child?: boolean) {
        super(parent);
        this.menu = menu;
        this.isBefore = before ?? false;
        this.isChild = child ?? false;
        this.isAfter = after ?? false;
    }

    public set menu(v: Menu) { this._menu = v; } public get menu(): Menu { return this._menu; } private _menu: Menu;
    public set isBefore(v: boolean) { this._isBefore = v; } public get isBefore(): boolean { return this._isBefore; } private _isBefore: boolean;
    public set isChild(v: boolean) { this._isChild = v; } public get isChild(): boolean { return this._isChild; } private _isChild: boolean;
    public set isAfter(v: boolean) { this._isAfter = v; } public get isAfter(): boolean { return this._isAfter; } private _isAfter: boolean;

    public handleMessage(message: ViewModelMessage) {
        if (message instanceof DragDropPossibilityChecker
            && message.droppedTo instanceof dropPlace
            && message.droppedTo == this
            && message.dragged instanceof Menu) {
            if (message.droppedTo.menu == message.dragged
                || (this.isChild && stringIsNullOrEmpty(this.menu.id) == false)) {
                return message.createRejectResponse();
            } else {
                return message.createAllowanceResponse(this.menu.getFullName());
            }
        } else if (message instanceof DropAppliedViewModelMessage && message.droppedTo instanceof dropPlace && message.dragged instanceof Menu) {
            if (this.isAfter) {
                this.menu.takeInAfterSibling(message.dragged);
            } else if (this.isBefore) {
                this.menu.takeInBeforeSibling(message.dragged);
            } else if (this.isChild) {
                this.menu.takeInChild(message.dragged);
            }
            return null;
        } else {
            return super.handleMessage(message);
        }
    }
}